import { FeatureConfiguration } from "..";
import { orderHubConnectionReducer } from "./reducers";
import { orderHubConnectionMiddleware } from "./middleware/orderHubConnectionMiddleware";

export default function (config: FeatureConfiguration) {
    config.middleware.unshift(orderHubConnectionMiddleware());
    config.reducers.orderHub = orderHubConnectionReducer;
}
